import React, { useRef } from "react";
import classes from "./AddYoutube.module.css";

function AddYoutube(props) {
  const naamRef = useRef('');
  const titelRef = useRef('');
  const srcRef = useRef('');
  const widthRef = useRef('');
  const heightRef = useRef('');

  function submitHandler(event) {
    event.preventDefault();

    // Add validation here?
    const movie = {
      naam: naamRef.current.value,
      titel: titelRef.current.value,
      src: srcRef.current.value,
      width: widthRef.current.value,
      height: heightRef.current.value,
    };

    console.log(movie);
    props.onAddMovie(movie);

    naamRef.current.value = null;
    titelRef.current.value = null;
    srcRef.current.value = null;
    widthRef.current.value = "420";
    heightRef.current.value = "315";
  }

  return (
    <form onSubmit={submitHandler}>
      <div className={classes.control}>
        <label htmlFor="naam">Naam</label>
        <input type="text" id="naam" ref={naamRef} />
      </div>
      <div className={classes.control}>
        <label htmlFor="titel">Titel</label>
        <input type="text" id="titel" ref={titelRef} />
      </div>
      <div className={classes.control}>
        <label htmlFor="src">URL</label>
        <input type="text" id="src" ref={srcRef} />
      </div>
      <div className={classes.control}>
        <label htmlFor="width">Breedte</label>
        <input type="text" id="width" defaultValue={"420"} ref={widthRef} />
      </div>
      <div className={classes.control}>
        <label htmlFor="height">Hoogte</label>
        <input type="text" id="height" defaultValue={"315"} ref={heightRef} />
      </div>
      <button>Toevoegen Video</button>
    </form>
  );
}

export default AddYoutube;